import { createSelector } from '@ngrx/store';
import { getIngredientByPLU } from '@shared/state';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';

export const getWizzardIngredientQuantity = (PLU: number) =>
    createSelector(getWizzardSimpleItem, getIngredientByPLU(PLU), (simpleItem, ingredientModel: APICommon.ProductIngredientExtended | APICommon.IngredientProductSwapExtended) => {
        if (!simpleItem) return null;

        if ('IngredientMode' in ingredientModel && ingredientModel.IngredientMode === OLO.Enums.INGREDIENT_MODE.OPTIONAL) {
            return simpleItem.IngredientsChanges?.IngredientsAdded.find((ing) => ing.IngredientPLU === PLU)?.Qty || 0;
        }

        return simpleItem.IngredientsChanges?._SelectedIngredientPLUs?.find((plu) => plu === PLU) ? 1 : 0;
    });
